var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PlatformRenderer',{scopedSlots:_vm._u([{key:"onMobile",fn:function(){return [_c('div',[_c('WCMobileSearchHeader',{attrs:{"suggestions":_vm.suggestions,"itemGroups":_vm.itemGroups},on:{"search":_vm.search,"fetchSuggestions":_vm.fetchSuggestions}})],1)]},proxy:true},{key:"onDesktop",fn:function(){return undefined},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }